require('./bootstrap');
require('alpinejs');
require('@popperjs/core');
window.modal = require('bootstrap/js/dist/modal');
window.alert = require('bootstrap/js/dist/alert');

window.scrollToFirstError = function() {
    let firstError = document.getElementsByClassName('invalid-feedback')[0] ?? null;

    if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
}

window.onProductClick = function (event) {
    const clicked = event.target
    const target = clicked.tagName.toLowerCase()
    const ignores = ['button', 'i', 'a']

    if (!ignores.includes(target)) {
        clicked.closest('.product').querySelector('.alpine-product-button').click();
    }
}
